import React, { useState } from "react";
import { toast } from "sonner";
import { Flag, EyeOff } from "lucide-react";
import { api, fmtError } from "@/lib/api";
import { AuthImage, Lightbox } from "@/components/AuthImage";

const ReportModal = ({ photo, onClose }) => {
  const [motif, setMotif] = useState("");
  const [busy, setBusy] = useState(false);
  const send = async () => {
    setBusy(true);
    try {
      await api.post(`/profile-media/photos/${photo.id}/report`, { motif });
      toast.success("Signalement transmis à l'équipe VosCompagnons"); onClose();
    } catch (err) { toast.error(fmtError(err)); } finally { setBusy(false); }
  };
  return (
    <div className="fixed inset-0 z-50 bg-black/50 flex items-center justify-center p-4" onClick={onClose}>
      <div className="card p-4 w-full max-w-md" onClick={(e) => e.stopPropagation()} data-testid="report-modal">
        <h3 className="font-semibold text-[#1F2933]">Signaler cette photo</h3>
        <p className="text-xs text-[#3E4C59] mt-1">Contenu inapproprié, personne identifiable sans accord, hors sujet…</p>
        <textarea className="textarea mt-3" rows={3} value={motif} onChange={(e) => setMotif(e.target.value)} placeholder="Motif du signalement" data-testid="report-motif" />
        <div className="flex justify-end gap-2 mt-3">
          <button className="btn-ghost" onClick={onClose}>Annuler</button>
          <button className="btn-primary" disabled={busy || motif.trim().length < 3} onClick={send} data-testid="report-submit">Signaler</button>
        </div>
      </div>
    </div>
  );
};

export const ProfileGallery = ({ photos = [], canReport, isOwner }) => {
  const [open, setOpen] = useState(null);
  const [reporting, setReporting] = useState(null);
  if (!photos.length) return null;
  return (
    <div className="mt-6" data-testid="profile-gallery">
      <h2 className="text-lg font-semibold text-[#1F2933]">Chantiers réalisés et équipe</h2>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-2 mt-2">
        {photos.map((ph) => (
          <figure key={ph.id} className="relative group" data-testid={`gallery-item-${ph.id}`}>
            <AuthImage url={ph.thumb_url} alt={ph.legende} onClick={() => setOpen(ph)}
              className={`w-full h-40 object-cover border border-[#E4E7EB] rounded-[4px] ${ph.hidden ? "opacity-50" : ""}`}
              testId={`gallery-thumb-${ph.id}`} />
            {ph.hidden && isOwner && (
              <span className="absolute top-1 left-1 inline-flex items-center gap-1 bg-[#FEF2F2] text-[#B91C1C] text-xs px-2 py-0.5 rounded-[4px] border border-[#FCA5A5]" title={ph.hidden_motif} data-testid={`gallery-hidden-${ph.id}`}>
                <EyeOff size={12} /> Masquée : {ph.hidden_motif}
              </span>
            )}
            {canReport && !ph.hidden && (
              <button type="button" onClick={() => setReporting(ph)} title="Signaler"
                className="absolute top-1 right-1 bg-white/95 border border-[#CBD5E1] text-xs px-2 py-0.5 rounded-[4px] opacity-0 group-hover:opacity-100 transition-opacity inline-flex items-center gap-1"
                data-testid={`gallery-report-${ph.id}`}><Flag size={12} /> Signaler</button>
            )}
            {ph.legende && <figcaption className="text-xs text-[#3E4C59] mt-1 truncate">{ph.legende}</figcaption>}
          </figure>
        ))}
      </div>
      {open && <Lightbox url={open.full_url} legende={open.legende} onClose={() => setOpen(null)} />}
      {reporting && <ReportModal photo={reporting} onClose={() => setReporting(null)} />}
    </div>
  );
};
